import { render, staticRenderFns } from "./RmaRequest.vue?vue&type=template&id=57beb8a6&"
import script from "./RmaRequest.vue?vue&type=script&lang=js&"
export * from "./RmaRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports